<template>
  <div>
    <div class="news-detail">
      <span @click="gotoHome" style="cursor: pointer">首页</span>
      <span>></span>
      <span style="color: #333333">海事申报</span>
    </div>
    <div class="declar-table">
      <el-form :inline="true" :model="formInline" class="form-inline">
        <el-form-item style="margin-right: 2.1429rem">
          <el-button
            type="success"
            @click="createList"
            size="medium"
            class="marit-button2"
            >创建申报</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            size="medium"
            class="marit-button"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-date-picker
            type="date"
            placeholder="开始时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="formInline.beginDate"
            style="margin-right: 1rem; width: 170px"
          ></el-date-picker>
          <el-date-picker
            type="date"
            placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="formInline.endDate"
            style="width: 170px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="width: 170px">
          <el-select v-model="formInline.recordState" placeholder="申报状态">
            <el-option label="申报状态" value=""></el-option>
            <el-option label="已保存" value="1"></el-option>
            <el-option label="已提交" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width: 170px">
          <el-input
            v-model="formInline.recordName"
            placeholder="请输入申报名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        border
        style="width: 1155px; margin: 0 auto"
        class="table-mar"
      >
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="recordName" label="申报名称"> </el-table-column>
        <el-table-column prop="signatureDate" label="日期" width="300">
        </el-table-column>
        <el-table-column prop="recordState" label="申报状态" width="150">
          <template slot-scope="scope">
            {{ formatStatus(scope.row.recordState) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button size="mini" @click="watchList(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.recordState == '1'"
              size="mini"
              type="success"
              @click="editList(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.recordState == '1'"
              size="mini"
              type="danger"
              @click="showDeleteConfirmation(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50]"
          :page-size="formInline.pageSize"
          :total="total"
          layout="prev, pager, next,sizes"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      class="dialog-color"
      v-dialogDrag:{dialogDrag}="true"
      title="创建申报选择"
      width="39.71rem"
      :visible.sync="dialogTableVisible"
    >
      <div class="flex-dialog">
        <div @click="innerList">船员服务业务开展情况年度备案表</div>
        <div @click="baseList">船员服务业务基础信息备案表</div>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-color"
      width="100%"
      title="船员服务业务开展情况年度备案表"
      top="0"
      :visible.sync="innerVisible"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-title">船员服务业务开展情况年度备案表</div>
      <div class="dialog-content">
        <div class="dialog-message" style="margin-bottom: 1rem">
          <div>基本信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label"> 单位名称 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.companyName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 经本单位管理上船工作的船员人数 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.manageCrewAmount"
              @blur="keyUpmanageCrewAmount('manageCrewAmount')"
              maxlength="9"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 与本单位劳动合同船员总人数 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.laborCrewAmount"
              @blur="keyUplaborCrewAmount('laborCrewAmount')"
              maxlength="9"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 与本单位服务合同船员总人数 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.serviceCrewAmount"
              @blur="keyUpserviceCrewAmount('serviceCrewAmount')"
              maxlength="9"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              年度服务船员情况(代理船员办理申请
              培训、考试、申领证书及派遣船员情况)
            </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.crewYearSituation"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              船员培训情况<br />上船船员岗前培训覆盖率
            </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.crewTrainRate"
              @blur="keyUpcrewTrainRate('crewTrainRate')"
              maxlength="3"
            ></el-input
            >%
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              《劳务派遣经营许可证》年度核验情况 (需及时补充报送年度核验结果)
            </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.yearVerification"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>船员信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <div style="width: 100%">
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="3" style="width: 15.71rem; padding: 0 1rem">
                上船船员任职资历情况
              </td>
              <td class="gray-td">在船1 - 4个月</td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne"
                  @blur="keyUpseniority1('seniority1')"
                  class="paperview-input-text"
                  style="width: 95%"
                  v-model="params.seniority1"
                  maxlength="9"
                ></el-input
                >人
              </td>
            </tr>
            <tr>
              <td class="gray-td">在船4 - 8个月</td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne"
                  class="paperview-input-text"
                  @blur="keyUpseniority2('seniority2')"
                  v-model="params.seniority2"
                  style="width: 95%"
                  maxlength="9"
                ></el-input
                >人
              </td>
            </tr>
            <tr>
              <td class="gray-td">在船8个月以上</td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne"
                  class="paperview-input-text"
                  @blur="keyUpseniority3('seniority3')"
                  style="width: 95%"
                  v-model="params.seniority3"
                  maxlength="9"
                ></el-input
                >人
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="3" style="width: 15.71rem; padding: 0 1rem">
                船员在船安全记录情况
              </td>
              <td class="gray-td">安全生产事故</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordProduct"
                  label="0"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordProduct"
                  label="1"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || productVisible"
                  class="paperview-input-text"
                  @blur="keyUpsafetyRecordProductNum('safetyRecordProductNum')"
                  v-model="params.safetyRecordProductNum"
                  style="width: 80%"
                  maxlength="9"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">人身意外伤害</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordAccident"
                  label="0"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordAccident"
                  label="1"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || accidentVisible"
                  class="paperview-input-text"
                  v-model="params.safetyRecordAccidentNum"
                  style="width: 80%"
                  @blur="
                    keyUpsafetyRecordAccidentNum('safetyRecordAccidentNum')
                  "
                  maxlength="9"
                ></el-input
                ><span>件次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因意外伤害导致死亡</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordDeath"
                  label="0"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordDeath"
                  label="1"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || deathVisible"
                  class="paperview-input-text"
                  v-model="params.safetyRecordDeathNum"
                  style="width: 80%"
                  @blur="keyUpsafetyRecordDeathNum('safetyRecordDeathNum')"
                  maxlength="9"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="2" style="width: 15.71rem; padding: 0 1rem">
                船员在船健康状况
              </td>
              <td class="gray-td">因疾病导致需下船治疗</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.healthConditionDisease"
                  label="0"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.healthConditionDisease"
                  label="1"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || diseaseVisible"
                  class="paperview-input-text"
                  v-model="params.healthConditionDiseaseNum"
                  style="width: 80%"
                  @blur="
                    keyUphealthConditionDiseaseNum('healthConditionDiseaseNum')
                  "
                  maxlength="9"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因疾病导致死亡</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.healthConditionDeath"
                  label="1"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.healthConditionDeath"
                  label="2"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || conditionVisible"
                  class="paperview-input-text"
                  v-model="params.healthConditionDeathNum"
                  style="width: 80%"
                  @blur="
                    keyUphealthConditionDeathNum('healthConditionDeathNum')
                  "
                  maxlength="9"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; border: 0px; font-weight: 600"
          >
            <tr>
              <td rowspan="2" style="width: 15.71rem; padding: 0 1rem"></td>
              <td class="gray-td">因船员服务业务接受行政处罚情况</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.administrativePenalties"
                  label="1"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.administrativePenalties"
                  label="2"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || penaltiesVisible"
                  class="paperview-input-text"
                  v-model="params.administrativePenaltiesNum"
                  style="width: 80%"
                  @blur="
                    keyUpadministrativePenaltiesNum(
                      'administrativePenaltiesNum'
                    )
                  "
                  maxlength="9"
                ></el-input
                ><span>次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因船员服务业务接受约谈、责令纠正情况</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.interviewCondition"
                  label="1"
                  :disabled="stateOne"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.interviewCondition"
                  label="2"
                  :disabled="stateOne"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  :disabled="stateOne || interviewVisible"
                  class="paperview-input-text"
                  v-model="params.interviewConditionNum"
                  style="width: 80%"
                  @blur="keyUpinterviewConditionNum('interviewConditionNum')"
                  maxlength="9"
                ></el-input
                ><span>次</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>法定代表人签字</div>
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS2"
          :label-style="LS2"
        >
          <el-descriptions-item>
            <template slot="label"> 法定代表人签字（盖章） </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="params.signatureName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 日 期 </template>
            <el-date-picker
              :disabled="stateOne"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="params.signatureDate"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem">
          <div>
            备注:1.统计时间节点为上年度1月1日至12月31日。2.存在因船员服务业务接受行政处罚或因船员服务业务接受约谈、责令纠正情况
          </div>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>上传文件</div>
        </div>
        <el-upload
          class="upload-demo"
          action
          :http-request="uploadFile"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :disabled="stateOne"
        >
          <el-button size="small" type="primary" v-if="!stateOne"
            >选择文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            注:请上传文件或者图片，支持pdf、docx、xls、xlsx、ceb等格式，最大限制30MB
          </div>
        </el-upload>
        <div class="list-file">
          <div class="save-file" @click="saveList" v-if="viewPower">保存</div>
          <div class="submit-file" @click="submitList" v-if="viewPower">
            提交
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-color"
      width="100%"
      title="船员服务业务基础信息备案表"
      top="0"
      :visible.sync="baseVisible"
      :before-close="handleClose"
      append-to-body
    >
      <div class="dialog-title">船员服务业务基础信息备案表</div>
      <div class="dialog-content">
        <div class="dialog-message" style="margin-bottom: 1rem">
          <div>基本信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label"> 单位名称 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.companyName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 统一社会信用代码 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.organizationCode"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位法人 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.legalPerson"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              :disabled="stateOne"
              @blur="testPhoneNum('legalPersonPhone')"
              class="paperview-input-text"
              v-model="baseParams.legalPersonPhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位负责人 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.inchargePerson"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              :disabled="stateOne"
              @blur="testPhoneNumTwo('inchargePhone')"
              class="paperview-input-text"
              v-model="baseParams.inchargePhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位联系人 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.contactsName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              oninput="value=value.replace(/[^\d]/g, '')"
              :disabled="stateOne"
              @blur="testPhoneNumThree('contactsPhone')"
              class="paperview-input-text"
              v-model="baseParams.contactsPhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 注册资金(元) </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.registeredCapital"
              @blur="keyUpregisteredCapital('registeredCapital')"
              maxlength="9"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 实缴注册资金(元) </template>
            <el-input
              oninput="value=value.replace(/[^\d]/g, '')"
              :disabled="stateOne"
              @blur="keyUprealPayCapical()"
              class="paperview-input-text"
              v-model="baseParams.realPayCapical"
              maxlength="9"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位性质 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.companyKind"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 是否含外资 </template>
            <el-radio
              v-model="baseParams.containForeignCapital"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.containForeignCapital"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 工商注册号 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.businessRegistrationNo"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 注册日期 </template>
            <el-date-picker
              type="date"
              :disabled="stateOne"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="params.registeredDate"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>其他信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label">
              单位英文名称(内河船员服务机构无须填写)
            </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.companyNameEn"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位实际地址 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.realAddress"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位注册地址 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.registerAddress"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证号码 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.licenseCode"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证有效期 </template>
            <el-date-picker
              type="date"
              :disabled="stateOne"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="baseParams.licenseValidityDate"
            ></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证许可机关 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.licenseAuthority"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 是否从事海船船员服务业务 </template>
            <div style="height: 2.8571rem">
              <el-radio
                v-model="baseParams.seafaringCrewService"
                label="0"
                :disabled="stateOne"
                >无</el-radio
              >
              <el-radio
                v-model="baseParams.seafaringCrewService"
                label="1"
                :disabled="stateOne"
                >有</el-radio
              >
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 其他资质信息 </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.otherQualificationInformation"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>附送材料列表(需上传原件)</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS3"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label">
              证明具有独立法人资格的营业执照复印件
            </template>
            <el-radio
              v-model="baseParams.attachedMaterials1"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials1"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
            <!-- <el-input v-model="baseParams.attachedMaterials1"></el-input> -->
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证副本的复印件 </template>
            <el-radio
              v-model="baseParams.attachedMaterials2"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials2"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 公司船员服务管理制度 </template>
            <el-radio
              v-model="baseParams.attachedMaterials3"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials3"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              船员服务业务项目及收费标准(需加盖公章)
            </template>
            <el-radio
              v-model="baseParams.attachedMaterials4"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials4"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 公司法人身份证复印件 </template>
            <el-radio
              v-model="baseParams.attachedMaterials5"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials5"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 委托书(非法人办理时提供) </template>
            <el-radio
              v-model="baseParams.attachedMaterials6"
              label="0"
              :disabled="stateOne"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials6"
              label="1"
              :disabled="stateOne"
              >有</el-radio
            >
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message-title" style="margin: 1rem 0">
          <div>
            登记信息接收机构（由企业填写所在辖区海事管理机构或地方交通运输主管部门名称）
          </div>
          <div>公司承诺</div>
        </div>
        <div class="input-textarea">
          <el-input
            :disabled="stateOne"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 3, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="baseParams.receiveDeptName"
          >
          </el-input>
          <el-input
            :disabled="stateOne"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 3, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="companyLogo"
          >
          </el-input>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>法定代表人签字</div>
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS2"
          :label-style="LS2"
        >
          <el-descriptions-item>
            <template slot="label"> 法定代表人签字（盖章） </template>
            <el-input
              :disabled="stateOne"
              class="paperview-input-text"
              v-model="baseParams.signatureName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 日 期 </template>
            <el-date-picker
              :disabled="stateOne"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="baseParams.signatureDate"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem">
          <div>上传文件</div>
        </div>
        <el-upload
          class="upload-demo"
          action
          :http-request="uploadFile"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :disabled="stateOne"
        >
          <el-button size="small" type="primary" v-if="!stateOne"
            >选择文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            注:请上传文件或者图片，支持pdf、docx、xls、xlsx、ceb等格式，最大限制30MB
          </div>
        </el-upload>
        <div class="list-file">
          <div class="save-file" @click="saveBaseList" v-if="viewPower">
            保存
          </div>
          <div class="submit-file" @click="submitBaseList" v-if="viewPower">
            提交
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/utils/dialog.js";
// import { apiRoot } from "@/config";
import { post } from "@/apis/axios";
import { apiRoot } from "@/config";
import {
  selectRecord,
  saveOrUpdate2,
  watchDetail,
  getOneFile,
  saveOrUpdate1,
  deleteList,
} from "@/apis/index";
// import { Loading } from "element-ui";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      stateOne: false,
      newsDetail: {},
      formInline: {
        pageSize: 10,
        pageNo: 1,
      },
      size: "small", // 或者根据需要设置初始值
      params: {},
      total: 0,
      tableData: [],
      fileList: [],
      baseParams: {},
      companyLogo:
        "本公司承诺严格遵守船员业务办理相关规定，规范开展船员相关各项业务，维护船员合法 权益。发生发现违规行为及损害船员权益行为，自愿接受约谈、整改、处罚、信誉管理、权限撤销等处理措施",
      fileType: [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "txt",
        "png",
        "jpg",
        "bmp",
        "jpeg",
        "ceb",
      ],
      dialogTableVisible: false,
      innerVisible: false,
      LS: {
        "text-align": "right",
        "font-weight": "600",
        height: "3rem",
        width: "20rem",
        "word-break": "keep-all",
        fontWeight: "600",
        color: "#333333",
      },
      CS: {
        display: "flex",
        width: "24.1429rem",
        "line-height": "2.8571rem",
        // height: "3rem",
      },
      LS2: {
        "text-align": "right",
        "font-weight": "600",
        height: "3rem",
        width: "20rem",
        "word-break": "keep-all",
        fontWeight: "600",
        color: "#333333",
      },
      CS2: {
        // height: "3rem",
        width: "24.1429rem",
        display: "flex",
        "line-height": "2.8571rem",
      },
      CS3: {
        height: "3rem",
        width: "24.1429rem",
        display: "flex",
        "line-height": "2.8571rem",
      },
      viewPower: true,
      baseVisible: false,
      productVisible: false,
      accidentVisible: false,
      deathVisible: false,
      diseaseVisible: false,
      conditionVisible: false,
      penaltiesVisible: false,
      interviewConditionNum: false,
      interviewVisible: false,
    };
  },
  mounted() {
    this.selectRecordList();
  },
  watch: {
    "params.safetyRecordProduct": function (newValue) {
      if (newValue == 0) {
        this.$set(this.params, "safetyRecordProductNum", 0);
        this.productVisible = true;
      } else {
        this.productVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.safetyRecordDeath": function (newValue) {
      if (newValue == 0) {
        this.$set(this.params, "safetyRecordDeathNum", 0);
        this.deathVisible = true;
      } else {
        this.deathVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.safetyRecordAccident": function (newValue) {
      if (newValue == 0) {
        this.$set(this.params, "safetyRecordAccidentNum", 0);
        this.accidentVisible = true;
      } else {
        this.accidentVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.healthConditionDisease": function (newValue) {
      if (newValue == 0) {
        this.$set(this.params, "healthConditionDiseaseNum", 0);
        this.diseaseVisible = true;
      } else {
        this.diseaseVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.healthConditionDeath": function (newValue) {
      if (newValue == 1) {
        this.$set(this.params, "healthConditionDeathNum", 0);
        this.conditionVisible = true;
      } else {
        this.conditionVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.administrativePenalties": function (newValue) {
      if (newValue == 1) {
        this.$set(this.params, "administrativePenaltiesNum", 0);
        this.penaltiesVisible = true;
      } else {
        this.penaltiesVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
    "params.interviewCondition": function (newValue) {
      if (newValue == 1) {
        this.$set(this.params, "interviewConditionNum", 0);
        this.interviewVisible = true;
      } else {
        this.interviewVisible = false;
      }
      // 可以在这里执行你想要的操作或触发其他方法
    },
  },
  created() {},
  methods: {
    testPhoneNum() {
      const phoneRes =
        /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
      let val = this.baseParams.legalPersonPhone;
      if (val) {
        if (!phoneRes.test(val)) {
          this.$message.error("请输入正确的手机号/座机号！");
          this.baseParams.legalPersonPhone = "";
        }
      }
    },
    testPhoneNumTwo() {
      const phoneRes1 =
        /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
      let val = this.baseParams.inchargePhone;
      if (val) {
        if (!phoneRes1.test(val)) {
          this.$message.error("请输入正确的手机号/座机号！");
          this.baseParams.inchargePhone = "";
        }
      }
    },
    testPhoneNumThree() {
      const phoneRes2 =
        /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
      let val = this.baseParams.contactsPhone;
      if (val) {
        if (!phoneRes2.test(val)) {
          this.$message.error("请输入正确的手机号/座机号！");
          this.baseParams.contactsPhone = "";
        }
      }
    },
    keyUpregisteredCapital() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.baseParams.registeredCapital) {
        if (!moneyReh.test(this.baseParams.registeredCapital)) {
          this.$message.error("请输入正数！");
          this.baseParams.registeredCapital = "";
        }
      }
    },
    keyUprealPayCapical() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.baseParams.realPayCapical) {
        if (!moneyReh.test(this.baseParams.realPayCapical)) {
          this.$message.error("请输入正数！");
          this.baseParams.realPayCapical = "";
        }
      }
    },
    keyUpmanageCrewAmount() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.manageCrewAmount) {
        if (!moneyReh.test(this.params.manageCrewAmount)) {
          this.$message.error("请输入正数！");
          this.params.manageCrewAmount = "";
        }
      }
    },
    keyUpcrewTrainRate() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.crewTrainRate) {
        if (!moneyReh.test(this.params.crewTrainRate)) {
          this.$message.error("请输入正数！");
          this.params.crewTrainRate = "";
        }
      }
    },
    keyUpseniority1() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.seniority1) {
        if (!moneyReh.test(this.params.seniority1)) {
          this.$message.error("请输入正数！");
          this.params.seniority1 = "";
        }
      }
    },
    keyUpseniority2() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.seniority2) {
        if (!moneyReh.test(this.params.seniority2)) {
          this.$message.error("请输入正数！");
          this.params.seniority2 = "";
        }
      }
    },
    keyUpseniority3() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.seniority3) {
        if (!moneyReh.test(this.params.seniority3)) {
          this.$message.error("请输入正数！");
          this.params.seniority3 = "";
        }
      }
    },
    keyUpsafetyRecordProductNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.safetyRecordProductNum) {
        if (!moneyReh.test(this.params.safetyRecordProductNum)) {
          this.$message.error("请输入正数！");
          this.params.safetyRecordProductNum = "";
        }
      }
    },
    keyUpserviceCrewAmount() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.serviceCrewAmount) {
        if (!moneyReh.test(this.params.serviceCrewAmount)) {
          this.$message.error("请输入正数！");
          this.params.serviceCrewAmount = "";
        }
      }
    },
    keyUpsafetyRecordAccidentNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.safetyRecordAccidentNum) {
        if (!moneyReh.test(this.params.safetyRecordAccidentNum)) {
          this.$message.error("请输入正数！");
          this.params.safetyRecordAccidentNum = "";
        }
      }
    },
    keyUplaborCrewAmount() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.laborCrewAmount) {
        if (!moneyReh.test(this.params.laborCrewAmount)) {
          this.$message.error("请输入正数！");
          this.params.laborCrewAmount = "";
        }
      }
    },
    keyUpsafetyRecordDeathNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.safetyRecordDeathNum) {
        if (!moneyReh.test(this.params.safetyRecordDeathNum)) {
          this.$message.error("请输入正数！");
          this.params.safetyRecordDeathNum = "";
        }
      }
    },
    keyUphealthConditionDiseaseNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.healthConditionDiseaseNum) {
        if (!moneyReh.test(this.params.healthConditionDiseaseNum)) {
          this.$message.error("请输入正数！");
          this.params.healthConditionDiseaseNum = "";
        }
      }
    },
    keyUphealthConditionDeathNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.healthConditionDeathNum) {
        if (!moneyReh.test(this.params.healthConditionDeathNum)) {
          this.$message.error("请输入正数！");
          this.params.healthConditionDeathNum = "";
        }
      }
    },
    keyUpadministrativePenaltiesNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.administrativePenaltiesNum) {
        if (!moneyReh.test(this.params.administrativePenaltiesNum)) {
          this.$message.error("请输入正数！");
          this.params.administrativePenaltiesNum = "";
        }
      }
    },
    keyUpinterviewConditionNum() {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (this.params.interviewConditionNum) {
        if (!moneyReh.test(this.params.interviewConditionNum)) {
          this.$message.error("请输入正数！");
          this.params.interviewConditionNum = "";
        }
      }
    },
    keyUp2(filed) {
      var moneyReh = /^[1-9]\d*(\.\d+)?$/;
      if (!moneyReh.test(this.Params[filed])) {
        this.$message.error("请输入正数！");
        this.Params[filed] = "";
      }
    },
    // keyUp17(){
    //   var moneyReh = /^\d{0,8}$/
    //   let val = this.params.registeredCapital
    //   if(!moneyReh.test(val)){
    //     this.$message.error('请输入1-9位正数！')
    //     this.params.registeredCapital=''
    //   }
    // },
    onSubmit() {
      this.formInline.pageNo = "1";
      this.selectRecordList();
    },
    async selectRecordList() {
      let res = await selectRecord(this.formInline);
      this.tableData = res.data.resultList;
      this.total = res.data.rowCount;
    },
    async watchList(item) {
      // console.log(item);
      this.stateOne = true;
      if (item.recordType == 2) {
        // this.dialogTableVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // let that = this;
        // console.log(res.data.appendixUrl);
        if (res.data.appendixUrl) {
          this.lookFileSrc(res.data.appendixUrl);
        } else {
          this.fileList = [];
        }
        // setTimeout(function () {
        //   // 这里是要执行的代码
        //   that.innerVisible = true;
        // }, 1);
        this.innerVisible = true;
        this.viewPower = false;
        this.params = res.data;
      } else if (item.recordType == 1) {
        // this.dialogTableVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // let that = this;
        // console.log(res.data.appendixUrl);
        if (res.data.appendixUrl) {
          this.lookFileSrc(res.data.appendixUrl);
        } else {
          this.fileList = [];
        }
        // setTimeout(function () {
        //   // 这里是要执行的代码
        //   that.baseVisible = true;
        // }, 1);
        this.baseVisible = true;
        this.viewPower = false;
        this.baseParams = res.data;
      }

      // console.log(res);
    },
    async lookFileSrc(src) {
      // console.log(src);
      if (src) {
        let url = await getOneFile({
          fileName: src[0] == "/" ? "file" + src : "file/" + src,
        });
        this.fileList = [{ name: "文件", url: url }];
      }

      // if (url) {
      //   window.open(url);
      // }
    },
    limitPhoneNum(value) {
      if (value.toString().length > 7) {
        this.params.manageCrewAmount = this.params.manageCrewAmount
          .toString()
          .slice(0, 7);
      }
    },
    limitPhoneNum2(value) {
      if (value.toString().length > 7) {
        this.params.laborCrewAmount = this.params.laborCrewAmount
          .toString()
          .slice(0, 7);
      }
    },
    limitPhoneNum3(value) {
      if (value.toString().length > 7) {
        this.params.serviceCrewAmount = this.params.serviceCrewAmount
          .toString()
          .slice(0, 7);
      }
    },
    limitPhoneNum4(value) {
      if (value.toString().length > 7) {
        this.params.crewTrainRate = this.params.crewTrainRate
          .toString()
          .slice(0, 7);
      }
    },
    async editList(item) {
      this.stateOne = false;
      if (item.recordType == 2) {
        // this.dialogTableVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // let that = this;
        // console.log(res.data.appendixUrl);
        if (res.data.appendixUrl) {
          this.lookFileSrc(res.data.appendixUrl);
        } else {
          this.fileList = [];
        }

        // setTimeout(function () {
        //   // 这里是要执行的代码
        //   that.innerVisible = true;
        // }, 1);
        this.innerVisible = true;
        this.viewPower = true;
        this.params = res.data;
      } else if (item.recordType == 1) {
        // this.dialogTableVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // let that = this;
        // console.log(res.data.appendixUrl);
        if (res.data.appendixUrl) {
          this.lookFileSrc(res.data.appendixUrl);
        } else {
          this.fileList = [];
        }

        // setTimeout(function () {
        //   // 这里是要执行的代码
        //   that.baseVisible = true;
        // }, 1);
        this.baseVisible = true;
        this.viewPower = true;
        this.baseParams = res.data;
      }
    },
    handleClose() {
      this.dialogTableVisible = false;
      this.innerVisible = false;
      this.baseVisible = false;
    },
    formatStatus(status) {
      if (status == 1) {
        return "已保存";
      } else {
        // 处理其他状态的逻辑
        return "已提交";
      }
    },
    innerList() {
      this.stateOne = false;
      this.params = {};
      this.viewPower = true;
      this.fileList = [];
      this.innerVisible = true;
    },
    baseList() {
      this.stateOne = false;
      this.baseParams = {};
      this.fileList = [];
      this.viewPower = true;
      this.baseVisible = true;
    },
    createList() {
      this.stateOne = false;
      // this.params = {};
      this.dialogTableVisible = true;
    },
    //保存申报
    async saveList() {
      this.params.companyId = sessionStorage.getItem("companyId");
      this.params.recordName = "船员服务业务开展情况年度备案表";
      this.params.recordState = "1";

      let res = await saveOrUpdate2(this.params);
      // console.log(res);
      if (res.code == "1") {
        this.innerVisible = false;
        this.dialogTableVisible = false;
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.selectRecordList();
      } else {
        this.$message.error("请检查格式!");
      }
    },
    // 提交申报
    async submitList() {
      this.params.companyId = sessionStorage.getItem("companyId");
      this.params.recordName = "船员服务业务开展情况年度备案表";
      this.params.recordState = "2";
      if (
        this.params.companyName &&
        this.params.manageCrewAmount &&
        this.params.laborCrewAmount &&
        this.params.serviceCrewAmount &&
        this.params.crewYearSituation &&
        this.params.crewTrainRate &&
        this.params.yearVerification &&
        this.params.seniority1 &&
        this.params.seniority2 &&
        this.params.seniority3 &&
        this.params.safetyRecordProduct &&
        this.params.safetyRecordAccident &&
        this.params.safetyRecordDeath &&
        this.params.healthConditionDisease &&
        this.params.healthConditionDeath &&
        this.params.administrativePenalties &&
        this.params.interviewCondition &&
        this.params.signatureName &&
        this.params.signatureDate
      ) {
        let res = await saveOrUpdate2(this.params);
        if (res.code == "1") {
          this.innerVisible = false;
          this.dialogTableVisible = false;
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.selectRecordList();
        } else {
          this.$message.error("请检查格式!");
        }
      } else {
        this.$message.error("请提交完整信息!");
      }
    },
    async saveBaseList() {
      this.baseParams.companyId = sessionStorage.getItem("companyId");
      this.baseParams.recordName = "船员服务业务基础信息备案表";
      this.baseParams.recordState = "1";
      let res = await saveOrUpdate1(this.baseParams);

      if (res.code == "1") {
        this.innerVisible = false;
        this.baseVisible = false;
        this.dialogTableVisible = false;
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.selectRecordList();
      } else {
        this.$message.error("请检查格式!");
      }
    },
    async submitBaseList() {
      this.baseParams.companyId = sessionStorage.getItem("companyId");
      this.baseParams.recordName = "船员服务业务基础信息备案表";
      this.baseParams.recordState = "2";
      if (
        this.baseParams.companyName &&
        this.baseParams.organizationCode &&
        this.baseParams.legalPerson &&
        this.baseParams.legalPersonPhone &&
        this.baseParams.inchargePerson &&
        this.baseParams.inchargePhone &&
        this.baseParams.contactsName &&
        this.baseParams.contactsPhone &&
        this.baseParams.registeredCapital &&
        this.baseParams.realPayCapical &&
        this.baseParams.companyKind &&
        this.baseParams.containForeignCapital &&
        this.baseParams.businessRegistrationNo &&
        this.baseParams.realAddress &&
        this.baseParams.registerAddress &&
        this.baseParams.licenseCode &&
        this.baseParams.licenseValidityDate &&
        this.baseParams.licenseAuthority &&
        this.baseParams.seafaringCrewService &&
        this.baseParams.otherQualificationInformation &&
        this.baseParams.attachedMaterials1 &&
        this.baseParams.attachedMaterials2 &&
        this.baseParams.attachedMaterials3 &&
        this.baseParams.attachedMaterials4 &&
        this.baseParams.attachedMaterials5 &&
        this.baseParams.attachedMaterials6 &&
        this.baseParams.receiveDeptName &&
        this.baseParams.signatureName &&
        this.baseParams.signatureDate
      ) {
        let res = await saveOrUpdate1(this.baseParams);
        if (res.code == "1") {
          this.innerVisible = false;
          this.baseVisible = false;
          this.dialogTableVisible = false;
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.selectRecordList();
        } else {
          this.$message.error("请检查格式!");
        }
      } else {
        console.log(this.baseParams);
        this.$message.error("请提交完整信息!");
      }
    },
    async delList(item) {
      // console.log(item);
      await deleteList({ id: item.id, recordType: item.recordType });
      this.selectRecordList();
    },
    showDeleteConfirmation(item) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.delList(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    handleSizeChange(size) {
      this.formInline.pageSize = size;
      // 调用后台接口或重新获取数据
      this.selectRecordList();
    },
    handleCurrentChange(val) {
      this.formInline.pageNo = val;
      // 调用后台接口或重新获取数据
      this.selectRecordList();
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      // console.log(this.fileList, "sb");
    },
    //自定义上传文件
    uploadFile(file) {
      // console.log(file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      // let obj = {
      //   fileName: file.name,
      //   fileSrc: "",
      //   data: fileData,
      // };
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          // message.success({
          //   content: "上传成功",
          //   duration: 3
          // });
          this.baseParams.appendixUrl = res.data;
          this.params.appendixUrl = res.data;
        })
        .catch(() => {});
      // console.log(obj);
      // console.log(file.file, "sb2");
    },
    //删除文件
    handleRemove(i) {
      // console.log(file, fileList);
      this.fileList.splice(i, 1);
    },
    // 点击文件
    handlePreview(file) {
      // console.log(file);
      window.open(file.url.data);
    },
    //超出文件个数的回调
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！",
      });
      return;
    },
    beforeUpload(file) {
      // console.log(file);
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型
        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 30; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          this.$showMessage("上传文件大小不能超过 30MB!");
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.fileType.includes(FileExt)) {
          return true;
        } else {
          this.$message.error("上传文件格式不正确!");
          return false;
        }
      }
    },
    gotoHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.gray-td {
  background: #f0f1f2;
  width: 21.1429rem;
  text-align: right;
  padding-right: 1rem;
  box-sizing: border-box;
}
.flex-td {
  display: flex;
  line-height: 2.8571rem;
}
.td-check {
  width: 25.7143rem;
}
</style>
